import {
  createContext,
  createRef,
  FC,
  RefObject,
  useContext,
  useState,
} from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import axios from 'axios';

export const RecaptchaContext = createContext<{
  recaptchaPassed: boolean;
  recaptchaExecuted: boolean;
  verifyRecaptcha: () => Promise<boolean>;
}>({
  recaptchaPassed: false,
  recaptchaExecuted: false,
  verifyRecaptcha: () => Promise.reject(new Error()),
});

const RecaptchaContextProvider: FC = ({ children }) => {
  const [isRecaptchaProcessed, setRecaptchaProcessed] = useState(false);
  const [isRecaptchaVerified, setRecaptchaVerified] = useState(false);
  const recaptchaRef: RefObject<ReCAPTCHA> = createRef();

  const verifyRecaptcha = async (): Promise<boolean> => {
    const recaptchaToken = await recaptchaRef.current?.executeAsync();

    if (!recaptchaToken) return false;

    const verifyResult = await axios.post<{ data: []; error: string }>(
      '/api/recaptcha/verify',
      { token: recaptchaToken },
    );

    setRecaptchaProcessed(true);

    if (verifyResult.data.error) {
      setRecaptchaVerified(false);
      return false;
    }

    setRecaptchaVerified(true);
    return true;
  };

  return (
    <RecaptchaContext.Provider
      value={{
        recaptchaPassed: isRecaptchaVerified,
        recaptchaExecuted: isRecaptchaProcessed,
        verifyRecaptcha,
      }}
    >
      {children}
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        sitekey={process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY!}
      />
    </RecaptchaContext.Provider>
  );
};

export const useRecaptcha = () => {
  return useContext(RecaptchaContext);
};

export default RecaptchaContextProvider;
